import React from 'react';
import {
    AppBar, Button,
    createStyles,
    makeStyles,
    Theme,
} from '@material-ui/core';
import Toolbar from '@material-ui/core/Toolbar';
import { useHistory } from 'react-router';
import clsx from 'clsx';

import logoImg from '../../images/logo.png';
import { usePartner } from '../../hooks/usePartner';
import { useLoginState } from '../../hooks/useLoginState';
import { useSetting } from '../../units/setting';

type DesktopAppBarProps = {
    className?: string,
    children?: React.ReactNode,
};

DesktopAppBar.defaultProps = {
    className: '',
    children: null,
};

const useStyles = makeStyles((theme: Theme) => createStyles({
    appBar: {
        backgroundColor: '#FFFFFF',
        borderBottomWidth: 1,
        borderBottomStyle: 'solid',
        borderBottomColor: theme.palette.divider,
    },
    toolbarContainer: {
        flex: 1,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        maxWidth: 1024,
        margin: '0 auto',
    },
    menu: {
        color: theme.palette.grey.A700,
        padding: theme.spacing(1, 2),
    },
    logo: {
        height: 54,
        marginRight: theme.spacing(2),
        cursor: 'pointer',
        padding: theme.spacing(1, 0),
    },
}));

function DesktopAppBar(props: DesktopAppBarProps): React.ReactElement {
    const {
        className,
        children,
    } = props;
    const classes = useStyles();
    const history = useHistory();
    const { clear } = useLoginState();
    const { partner } = usePartner();
    const { setting, setSetting } = useSetting();

    function handleLogoClick() {
        history.replace('/home');
    }

    function handleLoginClick() {
        if (window.location.pathname !== '/login') {
            history.push(`/login?redirect=${window.location.pathname}`);
        }
    }

    function handleLogoutClick() {
        if (window.location.pathname !== '/login') {
            clear();
            setSetting({
                ...setting,
                loginInfo: {
                    ...setting.loginInfo,
                    password: '',
                    expiryDate: 0,
                },
            });

            history.push(`/login?redirect=${window.location.pathname}`);
        }
    }

    return (
        <AppBar position="sticky" className={clsx(classes.appBar, className)} color="default">
            <Toolbar>
                <div className={classes.toolbarContainer}>
                    <img className={classes.logo} src={logoImg} alt="logo" onClick={handleLogoClick} />
                    <Button className={classes.menu} style={{ fontSize: 20 }} onClick={() => history.push('/')}>主選單</Button>
                    <Button className={classes.menu} style={{ fontSize: 20 }} onClick={() => history.push('/repair')}>線上報修</Button>
                    <Button className={classes.menu} style={{ fontSize: 20 }} onClick={() => history.push('/repair/search')}>報修查詢</Button>
                    <Button className={classes.menu} style={{ fontSize: 20 }} onClick={() => history.push('/memberService/action')}>會員服務</Button>
                    {partner ? (
                        <div style={{ flex: 1, textAlign: 'right' }}>
                            會員: {partner.name || ''}
                            <Button className={classes.menu} style={{ marginLeft: 8 }} variant="outlined" onClick={handleLogoutClick}>登出</Button>
                        </div>
                    ) : (
                        <div style={{ flex: 1, textAlign: 'right' }}>
                            <Button className={classes.menu} style={{ marginLeft: 8 }} variant="outlined" onClick={handleLoginClick}>登入</Button>
                        </div>
                    )}
                </div>
            </Toolbar>
            {children}
        </AppBar>
    );
}

export { DesktopAppBar };
